var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPatient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,34.75A12.75,12.75,0,1,0,27.25,22,12.76457,12.76457,0,0,0,40,34.75Zm0-24A11.25,11.25,0,1,1,28.75,22,11.26294,11.26294,0,0,1,40,10.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25,52V72h1.5V52A11.26294,11.26294,0,0,1,28,40.75H52A11.26294,11.26294,0,0,1,63.25,52V72h1.5V52A12.76457,12.76457,0,0,0,52,39.25H28A12.76457,12.76457,0,0,0,15.25,52Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.38281,46.66113l-.3833.33985-.3501-.30957a4.92005,4.92005,0,0,0-6.96191,6.9541l6.77832,6.88086a.74981.74981,0,0,0,1.06836,0l6.77441-6.877a4.92041,4.92041,0,0,0-3.479-8.39941A4.85344,4.85344,0,0,0,48.38281,46.66113ZM55.25,50.1709a3.40184,3.40184,0,0,1-1.00586,2.42187L48,58.93164l-6.248-6.34277a3.421,3.421,0,1,1,4.86914-4.80664l.88086.78222a.75082.75082,0,0,0,.9961,0l.91308-.8125a3.50063,3.50063,0,0,1,4.83692,0A3.39918,3.39918,0,0,1,55.25,50.1709Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPatient);
export default __webpack_public_path__ + "static/media/icon_patient.4b55a3600f1aff6428669cbb39125ff1.svg";
export { ForwardRef as ReactComponent };